import React from 'react';
import styles from './index.module.scss';

const Results = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='48.001'
        height='44'
        viewBox='0 0 48.001 44'
        className={className}
    >
        <path
            d='M-656,11386h-38a5.006,5.006,0,0,1-5-5v-29h48v29A5.006,5.006,0,0,1-656,11386Zm-9.713-20.6v9.6h2.306v-11.664h-3.858v2.065Zm-17.679-.417c.716,0,1.569.3,1.569,1.743,0,1.917-2.221,3.776-4.572,5.745l-.005,0c-.273.228-.555.464-.832.7v1.663h7.9v-1.854h-4.718l.181-.153c1.807-1.525,4.282-3.614,4.282-6.233a3.452,3.452,0,0,0-.947-2.521,3.913,3.913,0,0,0-2.831-1,3.9,3.9,0,0,0-2.7.949,4.047,4.047,0,0,0-1.188,2.954h2.175C-685.056,11365.713-684.443,11364.983-683.394,11364.983Zm6.561,3.36v1.889h6.784v-1.889ZM-651,11348h-48v-1a5.006,5.006,0,0,1,5-5h38a5.006,5.006,0,0,1,5,5v1h0Z'
            transform='translate(699.001 -11342.001)'
            className={styles.light}
        />
    </svg>
);

export default Results;
